<template>
  <Modal :id="'cmp-catalog-tracks-track_genres_modal'" @cancelled="onCancel">
    <template slot="header">{{ $dft.snakeCaseToWords("new_genre") }}</template>

    <template slot="body">
      <div class="body-container">
        <SearchList
          :id="'genre'"
          :items="items"
          :keyProperty="'genre_id'"
          :label="'genre_name'"
          :placeholder="'Search Genre'"
          :selectionNumber="'single'"
          @selected="onGenreSelected"
          @searched="onGenreSearched"
        />
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onAddGenre">
        {{ $t("new_genre") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { TracksService } from "../../services/tracks.service";
import { Subject } from "rxjs";

export default {
  components: {
    Modal,
    SearchList
  },
  props: ["selectedTrackDetails"],
  data() {
    return {
      unrelatedGenres: [],
      searchString: "",
      trackSearchString: "",
      searchSubject: new Subject(),

      selectedGenres: []
    };
  },
  mounted: async function() {
    const res = await TracksService.unrelatedGenres(this.track_id);
    this.unrelatedGenres = res.data.unrelated_genres;
  },
  computed: {
    track_id: function() {
      return this.$route.params.track_id;
    },
    items: function() {
      return this.unrelatedGenres || [];
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddGenre: async function() {
      // console.log('name & value ', this.trackSearchString);
      const res = await TracksService.newTrackGenre({
        track_id: this.track_id,
        genre_name: this.trackSearchString
      });

      // console.log('new data ', res.data);
      this.$emit("created", res.data);
    },
    onSearchInputKeyup: function(e) {
      this.trackSearchString = e.target.value;
      // console.log('trackSearchString', this.trackSearchString, e.target.value);
      this.searchSubject.next(this.trackSearchString);
    },

    onGenreSearched: async function(searchString) {
      this.trackSearchString = searchString;
      // const res = await TracksService.searchUnrelatedGenres(this.track_id, searchString);
      const res = await TracksService.searchUnrelatedGenres({
        track_id: this.track_id,
        search: searchString
      });
      this.unrelatedGenres = res.data.unrelated_genres;
    },

    onGenreSelected: async function(selectedGenre) {
      console.log(selectedGenre);
      if (Array.from(selectedGenre).length > 0) {
        const genre_id = Array.from(selectedGenre)[0];

        const res = await TracksService.addTrackGenre({
          track_id: this.track_id,
          genre_id
        });
        console.log(res.data, genre_id);
        this.$emit("added", res.data, this.track_id);
      }
    }
  }
};
</script>
